import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const CartIcon = memo(({ color = colors.primary.main, fontSize, className }: SvgIconProps) => {
  return (
    <SvgIcon width="18" height="17" viewBox="0 0 18 17" fill="none" style={{ fontSize }} className={className}>
      <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.84027 13.9843H11.6155C12.0945 13.9843 12.5736 13.6362 12.642 13.1491L14.4898 2.36006C14.5583 1.87281 14.9688 1.52478 15.5164 1.52478H16.2008"
          stroke={color}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0524 10.8511H4.77162C3.81351 10.8511 2.99227 10.2246 2.78697 9.25014L1.82885 5.28258C1.76042 5.14337 1.82885 4.93455 1.89729 4.86494C1.96573 4.72574 2.17103 4.65613 2.30791 4.65613H14.079"
          stroke={color}
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.30027 16.7824C6.79732 16.7824 7.20027 16.3726 7.20027 15.867C7.20027 15.3615 6.79732 14.9517 6.30027 14.9517C5.80321 14.9517 5.40027 15.3615 5.40027 15.867C5.40027 16.3726 5.80321 16.7824 6.30027 16.7824Z"
          fill={color}
        />
        <path
          d="M11.1003 16.7824C11.5974 16.7824 12.0003 16.3726 12.0003 15.867C12.0003 15.3615 11.5974 14.9517 11.1003 14.9517C10.6033 14.9517 10.2003 15.3615 10.2003 15.867C10.2003 16.3726 10.6033 16.7824 11.1003 16.7824Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
});
